import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  loading: boolean;
  name: string | undefined;

  handleClose(): void;

  handleDeleteFile(): void;
}

const DeleteSearchDialog: React.FC<Props> = ({ open, loading, name, handleClose, handleDeleteFile }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('deleteContactFileDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography className={classes.text}>
          <Trans i18nKey={'deleteContactFileDialogContent'} values={{ name }}>
            Soll die Datei <strong>{name}</strong> und alle damit verbundenen Kontakte wirklich gelöscht werden?
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} loading={loading} action={handleDeleteFile} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default DeleteSearchDialog;
